"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorHeader = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importDefault(require("react"));
const ui_1 = require("@grafana/ui");
const EditorHeader = ({ children }) => {
    const styles = (0, ui_1.useStyles2)(getStyles);
    return react_1.default.createElement("div", { className: styles.root }, children);
};
exports.EditorHeader = EditorHeader;
const getStyles = (theme) => ({
    root: (0, css_1.css)({
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(3),
        minHeight: theme.spacing(4),
    }),
});
//# sourceMappingURL=EditorHeader.js.map